import { CSSProperties } from "react"

export function processTemplate(template: string, variables: Record<string, any>): string {
  let processed = template

  for (const [key, value] of Object.entries(variables)) {
    const regex = new RegExp(`{{\\s*${key}\\s*}}`, "g")
    processed = processed.replace(regex, String(value || ""))
  }

  return processed
}

export const getContactStatusColor = (color?: string): CSSProperties => {

  const fallback = {
    backgroundColor: "rgba(107, 114, 128, 0.1)", // gray-500
    color: "#6b7280",
    borderColor: "rgba(107, 114, 128, 0.3)",
  };

  if (!color || typeof color !== "string") {
    return fallback;
  }

  // Ensure it starts with #
  const hex = color.startsWith("#") ? color : `#${color}`;

  // Validate full 6-digit hex
  const isValidHex = /^#([0-9A-F]{6})$/i.test(hex);
  if (!isValidHex) {
    return fallback;
  }

  const hexToRgba = (hex: string, alpha: number) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return {
    backgroundColor: hexToRgba(hex, 0.1),
    color: hex,
    borderColor: hexToRgba(hex, 0.3),
  };
};



export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
